import card from './card.js';
var layerStyles = {
  card: card
};
export { layerStyles as default };